import React from 'react';
import { CountriesWrapper } from './ShazamOverview.styles';
import { KPIListItemContentItemColumn } from 'components/data-containers/KPIs/shared';

import TopTerritories from 'components/data-containers/KPIs/Discovery/TopTerritories';
import { TopCountry } from 'components/data-containers/KPIs/Discovery/TopCountry';
import { TopCities } from 'components/data-containers/KPIs/Discovery/TopCities';

interface IShazamOverviewTerritoriesProps {
  isPending: boolean;
  topCountriesData: any;
  topCitiesData: any;
  countryFiltering: string;
}
const ShazamOverviewTerritories: React.FC<IShazamOverviewTerritoriesProps> = (
  props
) => {
  const {
    isPending,
    topCitiesData,
    topCountriesData,
    countryFiltering,
  } = props;
  return (
    <CountriesWrapper>
      <KPIListItemContentItemColumn>
        <TopTerritories
          label="Top Countries"
          pending={isPending}
          topTerritories={topCountriesData}
          TerritoryItem={TopCountry}
          getKey={(entity: any, item: any): string =>
            `top-country-${entity.entity.id}-${item.id}`
          }
          fullName={true}
        />
      </KPIListItemContentItemColumn>
      <KPIListItemContentItemColumn>
        <TopTerritories
          label={`Top ${countryFiltering} Cities`}
          pending={isPending}
          topTerritories={topCitiesData}
          TerritoryItem={TopCities}
          getKey={(entity: any, item: any): string =>
            `top-city-${entity.entity.id}-${item.cityId}`
          }
          type="city"
        />
      </KPIListItemContentItemColumn>
    </CountriesWrapper>
  );
};

export default ShazamOverviewTerritories;
